import React from 'react';
import { createRoot } from 'react-dom/client';
import '@wellness/design-tokens/tokens.css';
import './marketing.css';
import { App } from './App.js';

const node = document.getElementById('app');
if (!node) throw new Error('marketing root #app is missing');

createRoot(node).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
